"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
exports.Colors = {
    Red: {
        keyword: 'red',
        rgba: [255, 0, 0, 1],
    },
    DarkOpaqueRed: {
        keyword: 'red',
        rgba: [128, 0, 0, 0.5],
    },
    White: {
        keyword: 'white',
        rgba: [255, 255, 255, 1],
    },
    Black: {
        keyword: 'black',
        rgba: [0, 0, 0, 1],
    },
    Transparent: {
        keyword: 'transparent',
        rgba: [0, 0, 0, 0],
    },
    Violet: {
        keyword: 'violet',
        rgba: [238, 130, 238, 1],
    },
    LightBlue: {
        keyword: 'lightblue',
        rgba: [173, 216, 230, 1],
    },
    Yellow: {
        keyword: 'yellow',
        rgba: [255, 255, 0, 1],
    },
    Green: {
        keyword: 'green',
        rgba: [0, 128, 0, 1],
    },
    Gray: {
        keyword: 'gray',
        rgba: [128, 128, 128, 1],
    },
};
//# sourceMappingURL=colors.js.map